<template>
  <EnrollmentListing />
</template>
<script>
import EnrollmentListing from './EnrollmentListing.vue';

export default {
  name: 'Enrollments',
  components: {
    EnrollmentListing,
  },
}
</script>